import { onMounted, ref } from 'vue';
import { useSettings } from './use.settings.js';

export function useSelectedCategory(loadCards: (ids: number[]) => Promise<void>) {
  const selectedCategory = ref<string | null>(null);
  const { refreshSettings, settings } = useSettings();

  async function selectCategory(label: string, products?: number[]) {
    products ??= settings.value?.collection_groups.find((g) => g.label === label)?.products;

    if (!products) {
      return;
    }
    await loadCards(products);
    selectedCategory.value = label;
  }

  onMounted(async () => {
    refreshSettings();
    const defaultTag = settings.value?.default_checked_tag ?? settings.value?.collection_groups[0]?.label;

    if (defaultTag) {
      await selectCategory(defaultTag);
    }
  });

  return { selectedCategory, selectCategory };
}
